var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._g({staticClass:"base-svg",class:[
    _vm.isHover ? 'hover' : '',
    _vm.isSelected ? 'selected' : '',
    _vm.isDisabled ? 'disabled' : '' ],style:({ transform: ("rotate(" + _vm.degree + "deg)") }),domProps:{"innerHTML":_vm._s(require(("@/assets/svg/" + _vm.name + ".svg")))},on:{"mouseover":_vm.mouseover,"mouseout":_vm.mouseout}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }